/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogColor } from "../../d-dialog-color";
import { DThemeDarkDialogFitted } from "./d-theme-dark-dialog-fitted";

export class DThemeDarkDialogColor extends DThemeDarkDialogFitted implements DThemeDialogColor {}
